var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage-sport-modules justify-between"},[_c('LiveEvents'),(!_vm.isMobile)?_c('PreEvents'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }